import './index.css';
import { initializeKernel } from '@/core/kernel';

// Global error handlers for debugging
window.onerror = (message, source, lineno, colno, error) => {
  console.error('=== GLOBAL ERROR ===');
  console.error('Message:', message);
  console.error('Source:', source);
  console.error('Line:', lineno, 'Col:', colno);
  console.error('Error object:', error);
  console.error('Stack:', error?.stack);
  console.error('====================');
};

window.onunhandledrejection = (event) => {
  console.error('=== UNHANDLED PROMISE REJECTION ===');
  console.error('Reason:', event.reason);
  console.error('Stack:', event.reason?.stack);
  console.error('===================================');
};

// Initialize the application kernel
initializeKernel().catch((error) => {
  console.error('=== KERNEL INITIALIZATION ERROR ===');
  console.error('Error:', error);
  console.error('Stack:', error?.stack);
  console.error('===================================');
});
